module.exports = {"title":"Components","__content":"<h2 id=\"components\">Components</h2>\n<p>Reusable building blocks for your app or site! For the scope of this project only tabs &amp; dialogs have been covered.</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./~/markdown-with-front-matter-loader?passoverHTML=true!./src/documentation/Components/Index.md
// module id = 203
// module chunks = 0